<template>
  <div>
    <h1>查看班次表</h1>
    <el-form label-width="120px">
      <el-form-item label="选择网校">
        <el-select
          clearable
          v-model="model.maID"
          placeholder="网校"
          @change="getGrade"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          clearable
          @change="getCourse"
          v-model="model.chID"
          multiple
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="二级分类">
        <el-select
          clearable
          v-model="model.coID"
          multiple
          @change="getGrade"
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <template v-show="getgrade">
      <el-table :data="getgrade" border style="width: 100%">
        <el-table-column
          prop="createAt"
          label="创建时间"
          width="85"
          :formatter="formatDate"
        >
        </el-table-column>
        <el-table-column prop="major" label="网校" width="90">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.major" :key="tag.index">
              <el-tag>{{ tag.maName }}</el-tag>
            </span>
          </template>
        </el-table-column>
        <!--  <el-table-column prop="channel" label="一级分类" width="115">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.channel" :key="tag.index">
              <el-tag v-show="tag.chName" style="margin: 3px">{{
                tag.chName
              }}</el-tag>
            </span>
          </template>
        </el-table-column> -->
        <el-table-column prop="course" label="二级分类" width="150">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.course" :key="tag.index">
              <el-tag v-show="tag.coName" style="margin: 3px">{{
                tag.coName
              }}</el-tag>
            </span>
          </template>
        </el-table-column>
        <!--  <el-table-column prop="course" label="三级分类">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.course" :key="tag.index"
              ><el-tag v-show="tag.clName" style="margin: 3px">{{
                tag.clName
              }}</el-tag></span
            >
          </template>
        </el-table-column> -->
        <el-table-column prop="grName" label="班级名称" width="77">
        </el-table-column>
        <el-table-column
          prop="grYear"
          label="班级年份"
          width="55"
        ></el-table-column>
        <el-table-column
          prop="grPrice"
          label="班级价格"
          width="60"
        ></el-table-column>
        <el-table-column
          prop="salePrice"
          label="销售价格"
          width="60"
        ></el-table-column>

        <el-table-column prop="prpdf" label="电子资料" width="100">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.prPdfName" :key="tag.index"
              ><el-tag style="margin: 3px">{{ tag }}</el-tag></span
            >
          </template>
        </el-table-column>
        <el-table-column prop="prvideo" label="视频课程" width="180">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.prVideoName" :key="tag.index"
              ><el-tag style="margin: 3px">{{ tag }}</el-tag></span
            >
          </template>
        </el-table-column>
        <el-table-column prop="prservice" label="教学服务" width="180">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.prServiceName" :key="tag.index"
              ><el-tag style="margin: 3px">{{ tag }}</el-tag></span
            >
          </template>
        </el-table-column>
        <el-table-column prop="prteachway" label="学习方式">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.prTeachWayName" :key="tag.index">{{
              tag
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="prteachtime" label="课程期限">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.prTeachTimeName" :key="tag.index">{{
              tag
            }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button
              style="margin: 3px 3px 3px 3px"
              @click="$router.push(`/grade/edit/${scope.row._id}`)"
              type="primary"
              icon="el-icon-edit"
              size="small"
              plain
              >编辑</el-button
            >
            <el-button
              style="margin: 15px 3px 3px 3px"
              @click="gradeDelete(scope.row._id)"
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </template>
    <el-skeleton :loading="loading" :rows="10" animated />
    <!--  grade分类分页 -->
    <div class="grade-page">
      <el-pagination
        @size-change="changeSize"
        @current-change="currentChange"
        :current-page="currentPage"
        @prev-click="gradepre"
        @next-click="gradenext"
        background
        layout="prev, pager, next,total,jumper,sizes"
        :total="gradeLength"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { timerfilter } from "../util/timerfilter";

export default {
  data() {
    return {
      major: [],
      channel: [],
      course: [],
      clclass: [],
      getgrade: [],
      loading: true,
      model: {},

      gradeLength: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  methods: {
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }

      //console.log(getmajor.data);
    },
    async getChannel(chID) {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }

      //this.getGrade(chID);
    },
    async getCourse(chID) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID },
        });
        this.course = getcourse.data;

        this.getGrade(chID);
      } catch (error) {
        console.log(error);
      }
      //if (chID) this.chID = chID[0];
    },
    /* async getMaId(maID) {
      //this.maID = maID;
      this.getGrade(maID);
    }, */
    async getClass(coID) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID },
        });
        this.clclass = getclass.data;
        this.getGrade(coID);
      } catch (error) {
        console.log(error);
      }
      //if (coID) this.coID = coID[0];
    },
    async getGrade() {
      try {
        const getGrade = await this.$http.get("/category/getgrade", {
          params: {
            chID: this.model.chID,
            maID: this.model.maID,
            coID: this.model.coID,
            page: this.currentPage,
            size: this.pageSize,
          },
        });
        this.getgrade = getGrade.data[0].result;
        this.gradeLength = getGrade.data[0].resultLength[0].totalCount;
        this.loading = false;
      } catch (error) {
        console.log(error.message);
      }
    },
    //删除grade
    gradeDelete(id) {
      this.$confirm("此操作将永久删除且不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "waring",
        center: true,
      })
        .then(async () => {
          let res = await this.$http.get("/category/delgrade?_id=" + `${id}`);

          if (res.status === 203) {
            this.$message({ type: "success", message: res.data.msg });
            this.getGrade();
          } else {
            this.$message(res.message);
          }
        })
        .catch((res) => {
          if (res === "cancel") {
            this.$message({
              type: "info",
              message: "取消删除",
            });
          } else {
            //console.log(res);
            this.$message({
              type: "info",
              message: res.message,
            });
          }
        });
      /* const pricemsg = await this.$http.get(
        "/category/deleteprice?_id=" + `${id}`
      ); */
    },
    //grade分类分页
    async gradepre() {
      this.currentPage--;

      //this.getTertiary(this.pageSize);
      //console.log("上一页");
    },
    async gradenext() {
      this.currentPage++;
      // this.getTertiary(this.pageSize);
      //console.log(this.pageSize);
    },
    async changeSize(size) {
      this.pageSize = size;
    },
    async currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getGrade(this.currentPage);
      //console.log(this.currentPage);
    },
    //日期格式化插件
    formatDate(row, column) {
      let date = row[column.property];
      if (date == null) {
        return null;
      }
      //console.log(date)
      return timerfilter(date); //moment(date).format('YYYY-MM-DD HH:mm')
    },
  },
  created() {
    this.getMajor();
    this.getChannel();
    this.getGrade();
    //this.gradeDelete();
  },
};
</script>
